// extracted by css-extract-rspack-plugin
export default {"cls1":"JournalSubscriptionPage-cls1_Xy2","cls2":"JournalSubscriptionPage-cls2_57C JournalSubscriptionPage-cls1_Xy2"};